module.exports = __webpack_public_path__ + "static/media/9.58cb960c.png";